import { inferTimezone } from './dateTime';

export const populateHiddenTimezoneField = (): void => {
  const selector = '#user_timezone[data-autoselect]';
  const timezoneField = document.querySelector(selector);
  if (timezoneField) {
    (timezoneField as HTMLInputElement).value = inferTimezone();
  }
};
